"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRequestDefaults = exports.ApiVersion = void 0;
const types_1 = require("../types");
/**
 * Supported API versions.
 * @public
 */
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["V1"] = "v1";
})(ApiVersion || (exports.ApiVersion = ApiVersion = {}));
/**
 * Default values for an API request.
 * @public
 */
exports.ApiRequestDefaults = {
    apiVersion: ApiVersion.V1,
    league: types_1.League.NFL,
    method: 'GET',
};
//# sourceMappingURL=api-request.js.map